export default __webpack_public_path__ + "static/media/ios-safari.6988d182.png";